// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Touch / Kiosk Mode
 *
 * Scoped under body.touch-mode. Optimises the UI for large kiosk
 * touch screens: bigger hit targets, more comfortable spacing,
 * larger fonts and more generous padding. Applied via CSS custom
 * property overrides where possible, with a few targeted rules.
 */

body.touch-mode {
  /* ---- Typography / base font ---- */
  font-size: 18px;

  /* ---- Cloudscape spacing tokens (comfort) ----
     Scale up spacing scale approx 1.5x so containers and stacks
     breathe more on kiosk displays. */
  --space-scaled-xxxs-zpzmt5: 4px;
  --space-scaled-xxs-7597g1: 6px;
  --space-scaled-xs-fumogz: 12px;
  --space-scaled-s-i2pbm8: 18px;
  --space-scaled-m-b2sv6x: 24px;
  --space-scaled-l-d2qohu: 36px;
  --space-scaled-xl-jiwnuo: 48px;
  --space-scaled-xxl-21gx2w: 64px;
  --space-scaled-xxxl-cu2m1i: 96px;
}

/* ---- Larger hit targets for buttons ---- */
body.touch-mode button,
body.touch-mode [role="button"],
body.touch-mode .awsui-button,
body.touch-mode [class*="awsui_button_"],
body.touch-mode [class*="awsui_button-primary"] {
  min-height: 52px;
  font-size: 1.05rem;
}

/* Icon-only buttons keep their square shape but grow */
body.touch-mode [class*="awsui_variant-icon_"] {
  min-width: 52px;
  min-height: 52px;
}

/* ---- Top navigation utilities more tappable ---- */
body.touch-mode [class*="awsui_top-navigation_"] [class*="awsui_utility_"] {
  min-height: 56px;
  padding-top: 6px;
  padding-bottom: 6px;
}

body.touch-mode [class*="awsui_top-navigation_"] button {
  min-height: 48px;
}

/* ---- Form controls ---- */
body.touch-mode input,
body.touch-mode select,
body.touch-mode textarea,
body.touch-mode [class*="awsui_input_"] input,
body.touch-mode [class*="awsui_select-trigger_"],
body.touch-mode [class*="awsui_textarea_"] {
  min-height: 48px;
  font-size: 1.05rem;
}

/* Radio and checkbox targets */
body.touch-mode [class*="awsui_radio_"],
body.touch-mode [class*="awsui_checkbox_"] {
  min-height: 48px;
  padding-top: 8px;
  padding-bottom: 8px;
}

/* Tiles option (used on process page) */
body.touch-mode [class*="awsui_tile-container_"] {
  padding: 24px;
  min-height: 120px;
}

/* ---- Links and list rows ---- */
body.touch-mode a,
body.touch-mode [class*="awsui_link_"] {
  line-height: 1.6;
}

/* ---- Side navigation items bigger ---- */
body.touch-mode [class*="awsui_side-navigation_"] [class*="awsui_link_"],
body.touch-mode [class*="awsui_side-navigation_"] [class*="awsui_header-link_"] {
  min-height: 52px;
  display: flex;
  align-items: center;
  font-size: 1.05rem;
}

/* ---- Tabs bigger ---- */
body.touch-mode [class*="awsui_tabs-header-list_"] [role="tab"] {
  min-height: 56px;
  font-size: 1.05rem;
  padding-left: 20px;
  padding-right: 20px;
}

/* ---- Card headers and sections ---- */
body.touch-mode [class*="awsui_card-header_"],
body.touch-mode [class*="awsui_section-header_"] {
  padding-top: 16px;
  padding-bottom: 16px;
}

/* ---- Dropdown menu items ---- */
body.touch-mode [class*="awsui_options-list_"] [role="option"],
body.touch-mode [class*="awsui_dropdown_"] [role="menuitem"] {
  min-height: 52px;
  font-size: 1.05rem;
  padding-top: 10px;
  padding-bottom: 10px;
}

/* ---- Modal padding ---- */
body.touch-mode [class*="awsui_dialog_"] {
  padding: 8px;
}

/* ---- Header text a touch larger ---- */
body.touch-mode h1 { font-size: 2.25rem; }
body.touch-mode h2 { font-size: 1.75rem; }
body.touch-mode h3 { font-size: 1.4rem; }
`, "",{"version":3,"sources":["webpack://./src/styles/touch-mode.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF;EACE,qCAAqC;EACrC,eAAe;;EAEf;;sCAEoC;EACpC,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA,6CAA6C;AAC7C;;;;;EAKE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;;;;;;EAME,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;;EAEE,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;;EAEE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;;EAEE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,kCAAkC;AAClC;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,4BAA4B;AAC5B;EACE,YAAY;AACd;;AAEA,yCAAyC;AACzC,qBAAqB,kBAAkB,EAAE;AACzC,qBAAqB,kBAAkB,EAAE;AACzC,qBAAqB,iBAAiB,EAAE","sourcesContent":["/*\n * Touch / Kiosk Mode\n *\n * Scoped under body.touch-mode. Optimises the UI for large kiosk\n * touch screens: bigger hit targets, more comfortable spacing,\n * larger fonts and more generous padding. Applied via CSS custom\n * property overrides where possible, with a few targeted rules.\n */\n\nbody.touch-mode {\n  /* ---- Typography / base font ---- */\n  font-size: 18px;\n\n  /* ---- Cloudscape spacing tokens (comfort) ----\n     Scale up spacing scale approx 1.5x so containers and stacks\n     breathe more on kiosk displays. */\n  --space-scaled-xxxs-zpzmt5: 4px;\n  --space-scaled-xxs-7597g1: 6px;\n  --space-scaled-xs-fumogz: 12px;\n  --space-scaled-s-i2pbm8: 18px;\n  --space-scaled-m-b2sv6x: 24px;\n  --space-scaled-l-d2qohu: 36px;\n  --space-scaled-xl-jiwnuo: 48px;\n  --space-scaled-xxl-21gx2w: 64px;\n  --space-scaled-xxxl-cu2m1i: 96px;\n}\n\n/* ---- Larger hit targets for buttons ---- */\nbody.touch-mode button,\nbody.touch-mode [role=\"button\"],\nbody.touch-mode .awsui-button,\nbody.touch-mode [class*=\"awsui_button_\"],\nbody.touch-mode [class*=\"awsui_button-primary\"] {\n  min-height: 52px;\n  font-size: 1.05rem;\n}\n\n/* Icon-only buttons keep their square shape but grow */\nbody.touch-mode [class*=\"awsui_variant-icon_\"] {\n  min-width: 52px;\n  min-height: 52px;\n}\n\n/* ---- Top navigation utilities more tappable ---- */\nbody.touch-mode [class*=\"awsui_top-navigation_\"] [class*=\"awsui_utility_\"] {\n  min-height: 56px;\n  padding-top: 6px;\n  padding-bottom: 6px;\n}\n\nbody.touch-mode [class*=\"awsui_top-navigation_\"] button {\n  min-height: 48px;\n}\n\n/* ---- Form controls ---- */\nbody.touch-mode input,\nbody.touch-mode select,\nbody.touch-mode textarea,\nbody.touch-mode [class*=\"awsui_input_\"] input,\nbody.touch-mode [class*=\"awsui_select-trigger_\"],\nbody.touch-mode [class*=\"awsui_textarea_\"] {\n  min-height: 48px;\n  font-size: 1.05rem;\n}\n\n/* Radio and checkbox targets */\nbody.touch-mode [class*=\"awsui_radio_\"],\nbody.touch-mode [class*=\"awsui_checkbox_\"] {\n  min-height: 48px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n/* Tiles option (used on process page) */\nbody.touch-mode [class*=\"awsui_tile-container_\"] {\n  padding: 24px;\n  min-height: 120px;\n}\n\n/* ---- Links and list rows ---- */\nbody.touch-mode a,\nbody.touch-mode [class*=\"awsui_link_\"] {\n  line-height: 1.6;\n}\n\n/* ---- Side navigation items bigger ---- */\nbody.touch-mode [class*=\"awsui_side-navigation_\"] [class*=\"awsui_link_\"],\nbody.touch-mode [class*=\"awsui_side-navigation_\"] [class*=\"awsui_header-link_\"] {\n  min-height: 52px;\n  display: flex;\n  align-items: center;\n  font-size: 1.05rem;\n}\n\n/* ---- Tabs bigger ---- */\nbody.touch-mode [class*=\"awsui_tabs-header-list_\"] [role=\"tab\"] {\n  min-height: 56px;\n  font-size: 1.05rem;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n/* ---- Card headers and sections ---- */\nbody.touch-mode [class*=\"awsui_card-header_\"],\nbody.touch-mode [class*=\"awsui_section-header_\"] {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n\n/* ---- Dropdown menu items ---- */\nbody.touch-mode [class*=\"awsui_options-list_\"] [role=\"option\"],\nbody.touch-mode [class*=\"awsui_dropdown_\"] [role=\"menuitem\"] {\n  min-height: 52px;\n  font-size: 1.05rem;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n/* ---- Modal padding ---- */\nbody.touch-mode [class*=\"awsui_dialog_\"] {\n  padding: 8px;\n}\n\n/* ---- Header text a touch larger ---- */\nbody.touch-mode h1 { font-size: 2.25rem; }\nbody.touch-mode h2 { font-size: 1.75rem; }\nbody.touch-mode h3 { font-size: 1.4rem; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
